import { render, staticRenderFns } from "./GradeList.vue?vue&type=template&id=e6a65548&"
import script from "./GradeList.vue?vue&type=script&lang=js&"
export * from "./GradeList.vue?vue&type=script&lang=js&"
import style0 from "./GradeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports